<div class="agency-section"></div>
<div class="table-wrapper">
  <div class="table-header gap-4">
    <div class="align-items-center flex">
      <h2>Company Management</h2>
      <div class="user-label">
        <img alt="user.svg" src="../../assets/images/agencyies_m.svg" />
        <span>{{ totalCompanies }}</span>
      </div>
    </div>
    <div class="align-items-center flex gap-4">
      <div class="p-inputgroup table-search-wrapper">
        <span class="p-inputgroup-addon"
          ><img alt="search.svg" src="../../assets/images/search.svg"
        /></span>
        <input
          (keyup)="searchCompanies()"
          [(ngModel)]="searchCompany"
          class="table-search-field"
          placeholder="Search company by Name, Email, Phone"
          type="text"
        />
      </div>

      <div *ngIf="(currentUser.currentUserRole == iohSuperAdmin || currentUser.currentUserRole == iohAdmin) && selectedCompanies.length">
        <div class="field mb-0">
          <div class="p-inputgroup table-calendar-wrapper">
            <span class="p-inputgroup-addon"><img alt="calendar.svg" src="assets/images/calendar.svg"/></span>
            <p-calendar (onClear)="onCalendarClear()" (onSelect)="setDatesForExport()" [(ngModel)]="rangeDates" [readonlyInput]="true" class="w-full" dateFormat="{{datePickerFormat}}" inputId="range" ngDefaultControl placeholder="{{datePickerPlaceholder}}" selectionMode="range"></p-calendar>
            <button (click)="onCalendarClear()" *ngIf="rangeDates != null" class="clearBtn">
              <img alt="" src="assets/images/error.svg">
            </button>
          </div>
        </div>
      </div>

      <div
        *ngIf="(currentUser.currentUserRole == iohSuperAdmin || currentUser.currentUserRole == iohAdmin) && selectedCompanies.length"
        class="export-btn mr-3"
      >
        <!-- || !(rangeDates && rangeDates.length === 2 && rangeDates[0] && rangeDates[1]) -->
        <div class="export-report">
          <p-button label="Generate Reports"  [disabled]="!selectedCompanies.length"
          ></p-button>
          <p-dropdown #reportDropdown [disabled]="!selectedCompanies.length" placeholder="Generate Reports"
                      [options]="exportReportValues" (onChange)="onGenerateReportSelect($event)"
                      (mouseenter)="selectedCompanies.length ? reportDropdown.show() : ''"
                      (mouseleave)="selectedCompanies.length ? reportDropdown.hide() : ''"
                      [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"
          ></p-dropdown>
        </div>
      </div>
      <p-button
        (click)="onAddCompanyClick()"
        *ngIf="currentUser.currentUserRole != companyAdminUser"
        label="Add Company"
        styleClass="button-sm add-icon"
      ></p-button>
    </div>
  </div>
  <p-table
    #dt
    [(selection)]="selectedCompanies"
    [rowHover]="true"
    [rowsPerPageOptions]="[10, 20, 30]"
    [rows]="10"
    [showCurrentPageReport]="true"
    [value]="companies"
    (onRowSelect)="onRowSelect()"
    (onRowUnselect)="onRowUnSelect($event)"
    (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)"
    dataKey="id"
  >
    <ng-template pTemplate="header">
      <tr class="gc-table-filter">
        <th *ngIf="selectedRows.length !== 0 && (currentUser.currentUserRole == iohSuperAdmin || currentUser.currentUserRole == iohAdmin)" id="tableHeaderCheckbox"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
        <th class="w-4" id="company" *ngIf="isRowVisible('Company')">Company</th>
        <th class="w-3" id="email" *ngIf="isRowVisible('Email')">Email</th>
        <th class="w-2" id="phone" *ngIf="isRowVisible('Phone')">Phone</th>
        <th class="w-10rem" id="status" *ngIf="isRowVisible('Status')">
          <div class="flex align-items-center gap-2">
            <span>Status</span>
            <div class="filterClass">
              <img class="w-16" *ngIf="!selectedCompanyStatus"
                   (click)="statusDropdown.show()" src="assets/images/filter-outline.svg">
              <img class="w-18" *ngIf="selectedCompanyStatus && selectedCompanyStatus !== 'ALL'"
                   (click)="statusDropdown.show()" src="assets/images/filter-filled.svg">
              <p-dropdown
                #statusDropdown
                (onChange)="onChangeCompanyStatusFilter($event)"
                [(ngModel)]="selectedCompanyStatus"
                [autoDisplayFirst]="false"
                [options]="companyStatusFilterOptions"
              ></p-dropdown>
            </div>
          </div>
        </th>
        <th class="w-8rem" id="rowsSelected">
          <div class="gc-filter-TCOL-right">
            <img
              (click)="selectedCompanyRows.show()"
              alt="vector.svg"
              src="../../../assets/images/vector.svg"
            />
            <p-multiSelect
              #selectedCompanyRows
              (onChange)="onSelectedRowsChange()"
              [(ngModel)]="selectedRows"
              [displaySelectedLabel]="false"
              [filter]="true"
              [options]="visibleRows"
              appendTo="body"
            >
              <ng-template pTemplate="header">
                <span class="cursor-pointer close-icon" (click)="selectedCompanyRows.hide()"><i class="pi pi-times"></i></span></ng-template>
            </p-multiSelect>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template let-companies let-rowIndex="rowIndex" pTemplate="body">
      <tr class="p-selectable-row">
        <td *ngIf="selectedRows.length !== 0 && (currentUser.currentUserRole == iohSuperAdmin || currentUser.currentUserRole == iohAdmin)">
          <p-tableCheckbox [value]="companies"></p-tableCheckbox>
        </td>
        <td (click)="openEditCompanyForm(companies)" *ngIf="isRowVisible('Company')">
          <span class="p-column-title">Company</span>
          <div class="flex align-items-center gap-3">
            <div
              *ngIf="
                companies.logo !== null && companies.logo !== '';
                else elseBlock
              "
              class="gc-agency-img"
            >
              <img alt="company-img" src="{{ companies.logo }}" />
            </div>
            <ng-template #elseBlock>
              <div class="gc-agency-img">
                <app-avatar
                  [firstName]="companies.name"
                  [lastName]=""
                ></app-avatar>
              </div>
            </ng-template>
            <div>
              <p class="gc-agency-name">{{ companies.name }}</p>
              <p class="gc-agency-handle">{{ companies.id }}</p>
            </div>
          </div>
        </td>
        <td (click)="openEditCompanyForm(companies)" *ngIf="isRowVisible('Email')">
          <span class="p-column-title">Email</span>
          <span class="image-text">{{ companies.email }}</span>
        </td>
        <td (click)="openEditCompanyForm(companies)" *ngIf="isRowVisible('Phone')">
          <span class="p-column-title">Phone</span>
          <span class="image-text"
            >{{
              companies?.phoneNumber?.countryCode &&
              companies.phoneNumber?.number
                ? companies?.phoneNumber?.countryCode
                : ""
            }}
            {{
              companies?.phoneNumber?.number
                ? companies?.phoneNumber?.number
                : ""
            }}
          </span>
        </td>
        <td (click)="openEditCompanyForm(companies)" *ngIf="isRowVisible('Status')">
          <span class="p-column-title">Status</span>
          <span
            [style.color]="
              statusEnum[companies.status]
                ? statusEnum[companies.status | titlecase]
                : ''
            "
            class="image-text"
            >{{ companies.status | titlecase }}</span
          >
        </td>
        <!-- <td>
          <span class="p-column-title"></span>
          <button
            [matMenuTriggerFor]="menu"
            aria-label="Example icon-button with a menu"
            mat-icon-button
          >
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button (click)="onDropDownChange(rowIndex, 'Edit')" mat-menu-item>
              <span class="mat-opi-icon">
                <svg
                  fill="none"
                  height="16"
                  viewBox="0 0 16 16"
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 7V12.75C12 12.9142 11.9677 13.0767 11.9048 13.2284C11.842 13.38 11.75 13.5178 11.6339 13.6339C11.5178 13.75 11.38 13.842 11.2284 13.9048C11.0767 13.9677 10.9142 14 10.75 14H3.25C2.91848 14 2.60054 13.8683 2.36612 13.6339C2.1317 13.3995 2 13.0815 2 12.75V5.25C2 4.91848 2.1317 4.60054 2.36612 4.36612C2.60054 4.1317 2.91848 4 3.25 4H8.48375"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.373 1.66418C14.3274 1.614 14.272 1.57361 14.2103 1.54543C14.1486 1.51726 14.0818 1.50189 14.014 1.50025C13.9461 1.49862 13.8787 1.51075 13.8157 1.53592C13.7527 1.56108 13.6954 1.59876 13.6474 1.64668L13.2608 2.03136C13.214 2.07824 13.1877 2.14181 13.1877 2.20808C13.1877 2.27436 13.214 2.33792 13.2608 2.3848L13.6152 2.73855C13.6385 2.76189 13.6661 2.78041 13.6965 2.79304C13.7269 2.80568 13.7595 2.81219 13.7924 2.81219C13.8253 2.81219 13.8579 2.80568 13.8884 2.79304C13.9188 2.78041 13.9464 2.76189 13.9696 2.73855L14.3465 2.36355C14.5371 2.17324 14.5549 1.86324 14.373 1.66418Z"
                  />
                  <path
                    d="M12.4792 2.81241L6.83798 8.44366C6.80378 8.47773 6.77892 8.52002 6.76579 8.56647L6.50486 9.34366C6.4986 9.36475 6.49816 9.38714 6.50357 9.40845C6.50899 9.42977 6.52005 9.44923 6.5356 9.46479C6.55116 9.48034 6.57062 9.49141 6.59194 9.49682C6.61326 9.50223 6.63564 9.50179 6.65673 9.49554L7.43329 9.2346C7.47975 9.22148 7.52204 9.19662 7.55611 9.16241L13.1874 3.52054C13.2395 3.46788 13.2687 3.3968 13.2687 3.32273C13.2687 3.24865 13.2395 3.17757 13.1874 3.12491L12.8764 2.81241C12.8237 2.75984 12.7523 2.73032 12.6778 2.73032C12.6034 2.73032 12.5319 2.75984 12.4792 2.81241Z"
                  />
                </svg>
              </span>
              <span>Edit</span>
            </button>
            <button
              (click)="changeStatus(rowIndex)"
              *ngIf="currentUser.currentUserRole != companyAdminUser"
              mat-menu-item
            >
              <mat-icon class="inactive-icon" svgIcon="status"></mat-icon>
              <span>{{
                companies.status == "Inactive" ? "Active" : "Inactive"
              }}</span>
            </button>
            <button
              (click)="onDropDownChange(rowIndex, 'Delete')"
              *ngIf="currentUser.currentUserRole != companyAdminUser"
              mat-menu-item
            >
              <span class="mat-opi-icon">
                <svg
                  fill="none"
                  height="16"
                  viewBox="0 0 16 16"
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.5 3.5L4.125 13.5C4.15469 14.0778 4.575 14.5 5.125 14.5H10.875C11.4272 14.5 11.8397 14.0778 11.875 13.5L12.5 3.5"
                    stroke-linejoin="round"
                  />
                  <path d="M2.5 3.5H13.5" />
                  <path
                    d="M6 3.49993V2.24993C5.99971 2.15135 6.01892 2.0537 6.05651 1.96257C6.09409 1.87145 6.14933 1.78865 6.21903 1.71895C6.28873 1.64925 6.37153 1.59402 6.46265 1.55643C6.55378 1.51884 6.65143 1.49964 6.75 1.49993H9.25001C9.34858 1.49964 9.44624 1.51884 9.53736 1.55643C9.62849 1.59402 9.71128 1.64925 9.78099 1.71895C9.85069 1.78865 9.90592 1.87145 9.94351 1.96257C9.9811 2.0537 10.0003 2.15135 10 2.24993V3.49993"
                    stroke-linejoin="round"
                  />
                  <path d="M8 5.5V12.5" stroke-linejoin="round" />
                  <path d="M5.75 5.5L6 12.5" stroke-linejoin="round" />
                  <path d="M10.25 5.5L10 12.5" stroke-linejoin="round" />
                </svg>
              </span>
              <span>Delete</span>
            </button>
          </mat-menu>
        </td> -->
        <td></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" style="text-align: center">
          <span>
            <em class="pi pi-exclamation-circle mr-2"></em>
            No Companies found
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div>
    <p-paginator
      #paginator
      (onPageChange)="paginate($event)"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [rows]="noOfCompaniesPerRow"
      [totalRecords]="totalCompanies"
      styleClass="gc-paginator"
    ></p-paginator>
  </div>
</div>

<p-sidebar
  (onHide)="onSlideBarClose()"
  [(visible)]="display"
  [showCloseIcon]="false"
  [dismissible]="!isSendingAppLinkEmail"
  position="right"
>
  <ng-template pTemplate="header">
    <div class="align-items-center flex justify-content-between w-full">
      <h2 *ngIf="!showEditForm" class="gc-form-heading">Add Company</h2>
      <h2 *ngIf="showEditForm" class="gc-form-heading">Company Detail</h2>
      <span
        (click)="!isSendingAppLinkEmail && onSlideBarClose()"
        class="cursor-pointer"
        [class.disabled]="isSendingAppLinkEmail"
        [style.pointer-events]="isSendingAppLinkEmail ? 'none' : null"
      >
        <em class="pi pi-times"></em>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="popup-wrapper">
      <div class="form-container">
        <form *ngIf="addCompanyForm" [formGroup]="addCompanyForm">
          <div class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>Basic Information</h3>
            </div>
            <div class="sidebar-form">
              <div class="gc-profile-icon mb-0">
                <div class="gc-profile-wrap">
                  <img
                    [src]="
                      addCompanyForm.value?.logo
                        ? addCompanyForm.value?.logo
                        : '../../assets/images/agency-icon-blue.svg'
                    "
                    alt="company-img"
                  />
                </div>
                <div class="flex align-items-center gap-4">
                  <p-fileUpload
                    #fileUpload
                    (onSelect)="onSelect($event)"
                    [auto]="true"
                    [chooseIcon]="null"
                    [chooseLabel]="
                      addCompanyForm.value?.logo ? 'Update' : 'Upload Logo'
                    "
                    [class.profile-img-req]="!addCompanyForm.value?.logo"
                    [maxFileSize]="1000000"
                    accept="image/*"
                    mode="basic"
                    name="demo[]"
                    styleClass="change-img-btn"
                  ></p-fileUpload>
                  <p-button
                    (click)="deleteFile()"
                    *ngIf="addCompanyForm.value?.logo"
                    label="Remove"
                    styleClass="button-sm remove-img-btn"
                  ></p-button>
                </div>
              </div>
              <div class="max-img-note">
                The uploaded image should have a maximum width of 350 pixels
              </div>
              <div class="grid p-fluid">
                <div class="col-12">
                  <label>Company Name<span class="red">*</span></label>
                  <input
                    formControlName="name"
                    id="name"
                    name="name"
                    pInputText
                    placeholder="Company Name"
                    type="text"
                  />
                </div>
              </div>
              <div class="grid p-fluid">
                <div
                  class="col-12 md:col-6 gc-pr-12"
                  formGroupName="phoneNumber"
                >
                  <label>Phone</label>
                  <div class="flex gc-dialCode">
                    <p-dropdown
                      [options]="countries"
                      formControlName="countryCode"
                      optionLabel="dial_code"
                      optionValue="dial_code"
                    >
                      <ng-template let-country pTemplate="selectedItem">
                        <span
                          class="fi fi-{{
                            country.code.toLowerCase()
                          }} countryflag"
                        ></span>
                        <span class="country-code">
                          {{ country.dial_code }}</span
                        >
                      </ng-template>
                      <ng-template let-country pTemplate="item">
                        <span
                          class="fi fi-{{
                            country.code.toLowerCase()
                          }} countryflag"
                        ></span>
                        <span class="country-code">
                          {{ country.dial_code }}</span
                        >
                      </ng-template>
                    </p-dropdown>
                    <p-inputMask
                      formControlName="number"
                      mask="999-999-9999"
                      placeholder="(XXX) XXX-XXXX"
                    ></p-inputMask>
                  </div>
                </div>
                <div class="col-12 md:col-6 gc-pl-12" formGroupName="fax">
                  <label>Fax</label>
                  <div class="flex gc-dialCode">
                    <p-dropdown
                      [options]="countries"
                      formControlName="countryCode"
                      optionLabel="dial_code"
                      optionValue="dial_code"
                    >
                      <ng-template let-country pTemplate="selectedItem">
                        <span
                          class="fi fi-{{
                            country.code.toLowerCase()
                          }} countryflag"
                        ></span>
                        <span class="country-code">
                          {{ country.dial_code }}</span
                        >
                      </ng-template>
                      <ng-template let-country pTemplate="item">
                        <span
                          class="fi fi-{{
                            country.code.toLowerCase()
                          }} countryflag"
                        ></span>
                        <span class="country-code">
                          {{ country.dial_code }}</span
                        >
                      </ng-template>
                    </p-dropdown>
                    <p-inputMask
                      formControlName="number"
                      mask="999-999-9999"
                      placeholder="(XXX) XXX-XXXX"
                    ></p-inputMask>
                  </div>
                </div>
              </div>

              <div class="grid p-fluid">
                <div class="col-12 md:col-6 gc-pr-12">
                  <label>Email<span class="red">*</span></label>
                  <span class="p-input-icon-left">
                    <span class="gc-input-icon"
                      ><img
                        alt="email-icon.svg"
                        src="../../assets/images/email-icon.svg"
                    /></span>
                    <input
                      formControlName="email"
                      id="email"
                      name="email"
                      pInputText
                      placeholder="Email"
                      type="email"
                    />
                  </span>
                </div>

                <div class="col-12 md:col-6 gc-pl-12">
                  <label>Status</label>
                  <div>
                    <p-dropdown
                      [options]="statusValues"
                      formControlName="status"
                      placeholder="Select Status"
                    >
                      <ng-template let-status pTemplate="selectedItem"
                        ><span
                          [style.color]="
                            statusEnum[status.value]
                              ? statusEnum[status.value]
                              : ''
                          "
                          >{{ status.label }}</span
                        ></ng-template
                      >
                    </p-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="gc-form-section" formGroupName="address">
            <div class="gc-form-section-heading">
              <h3>Address</h3>
            </div>
            <div class="sidebar-form">
              <div class="grid p-fluid">
                <div class="col-12 md:col-6 gc-pl-12">
                  <label>Line 1<span class="red">*</span></label>
                  <input
                    formControlName="line1"
                    id="line1"
                    name="line1"
                    pInputText
                    placeholder="Line 1"
                    type="text"
                  />
                </div>
                <div class="col-12 md:col-6 gc-pr-12">
                  <label>Line 2</label>
                  <input
                    formControlName="line2"
                    id="line2"
                    name="line2"
                    pInputText
                    placeholder="Line 2"
                    type="text"
                  />
                </div>
              </div>
              <div class="grid p-fluid">
                <div class="col-12 md:col-6 gc-pl-12">
                  <label>City<span class="red">*</span></label>
                  <input
                    formControlName="city"
                    id="addressCity"
                    name="addressCity"
                    pInputText
                    placeholder="City"
                    type="text"
                  />
                </div>
                <div class="col-12 md:col-6 gc-pr-12">
                  <label>State<span class="red">*</span></label>
                  <input
                    formControlName="state"
                    id="addressState"
                    name="addressState"
                    pInputText
                    placeholder="State"
                    type="text"
                  />
                </div>
              </div>
              <div class="grid p-fluid">
                <div class="col-12 md:col-6 gc-pl-12">
                  <label>Zipcode<span class="red">*</span></label>
                  <input
                    formControlName="postalCode"
                    id="postalCode"
                    name="postalCode"
                    pInputText
                    placeholder="Zipcode"
                    type="text"
                  />
                </div>
                <div class="col-12 md:col-6"></div>
              </div>
            </div>
          </div>
          <div *ngIf="currentUser?.is_super_admin || currentUser?.is_IOH_admin" class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>Set NonMDM Customer Settings</h3>
            </div>
              <div class="">
                <div class="col-12 md:col-12 gc-pr-12">
                  <div>
                    <p-dropdown
                    [options]="nonMdmCustomerOptions"
                    formControlName="nonMDMCustomer" placeholder="Select Option">
                    <ng-template let-rotationSet pTemplate="selectedItem"
                      ><span>{{ rotationSet?.label }}</span></ng-template>
                  </p-dropdown>
                </div>
              </div>
          </div>
          </div>
          <div *ngIf="showEditForm && isSuperAdminOnlyRole && addCompanyForm?.value?.nonMDMCustomer === NonMDMCustomerEnum.Enabled" class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>Set App Link</h3>
              <span
                (click)="sendBulkEmail()"
                class="resend-btn cursor-pointer"
                [class.disabled]="isSendingAppLinkEmail"
                [style.pointer-events]="isSendingAppLinkEmail ? 'none' : null"
              >
                Send bulk Email
              </span>
            </div>
            <div class="sidebar-form">
              <div class="grid p-fluid">
                <div class="col-12">
                  <label>Select App Link<span class="red">*</span></label>
                  <p-dropdown
                    [disabled]="isFetchingAppLinks || isSendingAppLinkEmail"
                    [options]="appLinkOptions"
                    [(ngModel)]="selectedAppLinkId"
                    placeholder="Select App Link"
                    [ngModelOptions]="{standalone: true}"
                    [filter]="true"
                    appendTo="body"
                    optionLabel="label"
                    optionValue="value"
                    styleClass="w-full app-link-dropdown"
                  ></p-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>Set Organization ID Rotation</h3>
            </div>
              <div class="">
                <div class="col-12 md:col-12 gc-pr-12">
                  <div>
                    <p-dropdown
                    [options]="rotationSetOptions"
                    formControlName="isRotating"
                    placeholder="Select Duration">
                    <ng-template let-rotationSet pTemplate="selectedItem"
                      ><span>{{ rotationSet?.label }}</span></ng-template>
                  </p-dropdown>
                </div>
              </div>
          </div>
          </div>
           <div class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>Set Organization ID Rotation Duration</h3>
            </div>
              <div class="">
                <div class="col-12 md:col-12 gc-pr-12">
                  <div>
                    <p-dropdown
                    [options]="rotationDurationOptions"
                    formControlName="rotatingDuration"
                    placeholder="Select Duration">
                    <ng-template let-rotationDuration pTemplate="selectedItem"
                      ><span>{{ rotationDuration?.label }}</span></ng-template>
                  </p-dropdown>
                </div>
              </div>
          </div>
          </div>
          <div class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>User Login with PCID</h3>
            </div>
              <div class="">
                <div class="col-12 md:col-12 gc-pr-12">
                  <div>
                    <p-dropdown  [options]="registrationTypeFilterOptions"
                      formControlName="loginWithPCIDenabled">
                      <ng-template let-registrationType pTemplate="selectedItem"
                        ><span>{{ registrationType?.label }}</span></ng-template>
                  </p-dropdown>
                </div>
              </div>
          </div>
          </div>
          <div class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>Add No of days to delete report</h3>
            </div>

            <div class="col-12 md:col-12 gc-pr-12">
              <p-dropdown  [options]="reportDeleteDaysOptions"
                      formControlName="reportDeleteDays">
                      <ng-template let-reportDeleteType pTemplate="selectedItem"
                        ><span>{{ reportDeleteType?.label }}</span></ng-template>
                  </p-dropdown>
              </div>

</div>
          <div *ngIf="showEditForm" class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>Associated Agencies</h3>
            </div>
            <div class="">
              <div class="asso-container">
                <div *ngIf="attachedAgencies.length > 0 else noAgency" class="associated-agencies-parent">
                <div class="flex align-items-center gap-3 border-black-alpha-20 px-3 py-2 cursor-pointer associated-agencies"
                     [ngClass]="i != attachedAgencies.length - 1 ? 'border-bottom-1' : ''"
                     *ngFor="let attachedAgency of attachedAgencies; let i = index" (click)="onAgencyClick(attachedAgency?.value)">
                  <div
                    class="gc-agency-img border-black-alpha-20 border-1">
                    <img alt="company-img" src="{{ attachedAgency?.icon }}" />
                  </div>
                  <span class="text-sm">{{ attachedAgency?.label }}</span>
                </div>
                  </div>
                <ng-template #noAgency>
                  <div class="flex align-items-center gap-3 border-black-alpha-20 px-3 py-2">
                    <span class="text-center">No agency associated</span>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="gc-slide-footer flex justify-content-end gap-4">
      <button
        (click)="onDeleteClick()"
        *ngIf="showEditForm"
        class="btn-delete"
        label="Delete"
        [disabled]="isSendingAppLinkEmail"
        pButton
      ></button>
      <button
        (click)="onSlideBarClose()"
        class="btn-cancel"
        label="Cancel"
        [disabled]="isSendingAppLinkEmail"
        pButton
        type="submit"
      ></button>
      <button
        (click)="checkIfEmailExists()"
        *ngIf="!showEditForm"
        [disabled]="!addCompanyForm.valid"
        label="Add"
        pButton
        type="submit"
      ></button>
      <button
        (click)="onUpdateClick()"
        *ngIf="showEditForm"
        [disabled]="!addCompanyForm.valid || isSendingAppLinkEmail"
        label="Update"
        pButton
        type="submit"
      ></button>
    </div>
  </ng-template>
</p-sidebar>
